<template>
    <div class="flat-index"> 
        <div v-if="isDianDianHome" class="fi-pc">
            <div class="fi-main">
                <fi-header></fi-header>
                <div class="banner-container">
                    <div class="banner-left">
                        <ul>
                            <li>
                                <div>
                                    <div class="ht">
                                        <h2>借点</h2>
                                        <hr>
                                    </div>
                                </div>
                                <strong>想你所想,急你所急</strong>
                                <p>点一点，最高20万额度，日利息低至0.025%起，借10000最低每天只需2元利息。 资质达标1秒审核，3秒放款。</p>
                            </li>
                            <li>
                                <div>
                                    <div class="ht">
                                        <h2>点点商城</h2>
                                        <hr>
                                    </div>
                                </div>
                                <strong>潮流好物,应有尽有</strong>
                                <p>点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。</p>
                            </li>
                            <li>
                                <div>
                                    <div class="ht">
                                        <h2>点点闪付</h2>
                                        <hr>
                                    </div>
                                </div>
                                <strong>与中国银联深度合作</strong>
                                <p>点一点，支持全国百万商户线上线下消费， 可享受支付立减专属优惠，安全、省心、省钱。</p>
                            </li>
                            <li>
                                <div>
                                    <div class="ht">
                                        <h2>生活缴费</h2>
                                        <hr>
                                    </div>
                                </div>
                                <strong>足不出户,生活助手</strong>
                                <p>点一点，所有水、电、煤等生活缴费， 在手机上即可完成。 生活已然艰辛，点点为您省心。</p>
                            </li>
                            <li>
                                <div>
                                    <div class="ht">
                                        <h2>娱乐充值</h2>
                                        <hr>
                                    </div>
                                </div>
                                <strong>游戏、视频、礼品卡</strong>
                                <p>点一点，畅玩无限，享轻奢新主义， 为生活添色彩。</p>
                            </li>
                            <li>
                                <div>
                                    <div class="ht">
                                        <h2>办信用卡</h2>
                                        <hr>
                                    </div>
                                </div>
                                <strong>精选各大银行易下好卡</strong>
                                <p>点一点，即刻在线完成申请， 额度大、颜值高、审批快、权益多, 让办卡不再困难。</p>
                            </li>
                        </ul>
                    </div>
                    <div class="banner-right">
                        <ul>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                    <div class="pagination">
                        <div v-for="(item,index) in page" :key="index" class="dh-page">
                            <span class="m-page"></span>
                        </div>
                    </div>
                </div>
                <div class="nav-container">
                    <ul>
                        <li v-for="(item,index) in navText" @click="paginationHandle(index)" :class="{'active':navActive[index]}" :key="index"><i></i>{{item}}</li>
                    </ul>
                </div>
                <div class="version">
                    <ul>
                        <li @mouseover="versionOverHandle(0)" @mouseout="versionOutHandle">
                            <div class="v-btn" :class="{'active':isQrCode[0]}">
                                <i></i>IOS下载
                            </div>
                            <div v-if="isQrCode[0]" class="qrcode-pic"></div>
                        </li>
                        <li @mouseover="versionOverHandle(1)" @mouseout="versionOutHandle">
                            <div class="v-btn" :class="{'active':isQrCode[1]}">
                                <i></i>Android下载
                            </div>
                            <div v-if="isQrCode[1]" class="qrcode-pic"></div>
                        </li>
                        <!-- <li @mouseover="versionOverHandle(2)" @mouseout="versionOutHandle">
                            <div class="v-btn" :class="{'active':isQrCode[2]}">
                                <i></i>Wechat关注
                            </div>
                            <div v-if="isQrCode[2]" class="qrcode-pic"></div>
                        </li> -->
                    </ul>
                </div>
                <div class="home-user"></div>
                <div class="diandian-pro">
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
                <div class="title-bg dd-title"></div>
                <div class="ly-container">
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
                <div class="title-bg hz-title"></div>
                <div class="fd-icon"></div>
            </div>
            <div v-if="isJgWin" class="dd-jg-win">
                <div class="jg-main">
                    <div @click="isJgWin=false" class="close"></div>
                    <div class="jg-bg"></div>
                    <div class="info"><a href="#/pdxy"></a></div>
                </div>
            </div>
            <fi-footer></fi-footer>
        </div>
        <div v-if="isBepoint">
            <iframe src="https://one.zhongan.com/fcp/fdyx/index.htm" class="fdyx"></iframe>
        </div>
    </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
import {
    os
} from '../utils/tool'

import FiHeader from '../components/header'
import FiFooter from '../components/footer'

export default {
    components: {
        swiper,
        swiperSlide,
        FiHeader,
        FiFooter
    },
    data() {
        const _vue = this;
        return {
            isPc: false,
            isMobile: false,
            nowIndex: 0,
            page: 6,
            isMoveing: true,
            navText: ['借点', '点点商城', '点点闪付', '生活缴费', '充值娱乐', '办信用卡'],
            navActive: [true],
            isQrCode: [false, false, false],
            tapTimer: null,
            isDianDianHome: false,
            isBepoint: false,
            isJgWin:true,
            swiperOption: {
                // direction: 'vertical',
                // mousewheel: true,
                // parallax: true,
                // touchRatio: 0.5,
                // resistanceRatio: 0,
                speed: 450,
                height: 420,
                // autoplay: {
                //     delay: 5000
                // },
                loop: true,
                // effect: 'fade',
                // allowTouchMove: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function (e) {

                        // console.log(nowActiveIndex, this.activeIndex, 'index');
                    },
                    transitionEnd: function () {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start()
                        }
                    }
                }
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    watch: {
        nowIndex(n, o) {
            // console.log(n,o,'');
            //进度条  清除上一个定时器
            cancelAnimationFrame(this.aMPage[o].raf);
            // cancelAnimationFrame(this.aMPage[n].raf);
            this.navActive = []
            this.navActive[n] = true
            this.aMPage[o].style[this.transform] = 'translate3d(-100%,0,0)'
            this.moveBar(this.aMPage[n], 0, 6000)
            this.bannerMoveHandle(n, o)
        }
    },
    created() {
        if (os().isIos || os().isAndroid) {
            this.isMobile = true
        } else {
            this.isPc = true
        }
    },
    mounted() {
        if (window.location.host == 'www.bepoint.cn') {
            document.title = '深圳蜂点科技有限公司';
            this.isBepoint = true
        } else {
            //点点
            document.title = '点点_点点app_点点官网_国内领先的智能生活金融服务平台';
            this.isDianDianHome = true
            this.$nextTick(() => {
                this.bannerLeft = document.getElementsByClassName('banner-left')[0]
                this.leftLi = this.bannerLeft.getElementsByTagName('li')
                this.bannerRight = document.getElementsByClassName('banner-right')[0]
                this.rightLi = this.bannerRight.getElementsByTagName('li')

                this.pfx()
                this.initElement()
            })
        }
    },
    methods: {
        pfx() {
            var prefix = (function () {
                var tempDom = document.createElement('div').style,
                    prefixStrArr = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                    sPre;
                for (var i = 0; i < prefixStrArr.length; i++) {
                    if (prefixStrArr[i] + 'ransform' in tempDom) {
                        sPre = prefixStrArr[i].substring(0, prefixStrArr[i].length - 1);
                        window.cssPrefix = sPre ? sPre : '';
                        window.css_Prefix = sPre ? '-' + sPre.toLowerCase() + '-' : '';
                    }
                }
                tempDom = null;
                return function (style) {
                    if (sPre === '') return style;
                    style = style.charAt(0).toUpperCase() + style.substring(1);
                    return sPre + style;
                }
            })();
            var _vTransitionEnd = {
                '': 'transitionend',
                'webkit': 'webkitTransitionEnd',
                'Moz': 'transitionend',
                'O': 'otransitionend',
                'ms': 'MSTransitionEnd'
            };
            this.transform = prefix('transform')
            this.transition = prefix('transition')
            this.transitionEnd = _vTransitionEnd[window.cssPrefix]
            var transitionDelay = prefix('transitionDelay'),
                transitionDuration = prefix('transitionDuration'),
                transitionProperty = prefix('transitionProperty'),
                transitionTimingFunction = prefix('transitionTimingFunction');
        },
        initElement() {
            this.aMPage = document.getElementsByClassName('m-page')
            this.moveBar(this.aMPage[0], 0, 6000)
        },
        moveFn() {
            this.isMoveing = true
        },
        versionOverHandle(index) {
            // this.isQrcode.splice(0,1,true)
            this.isQrCode = [false, false, false]
            this.isQrCode[index] = true

        },
        versionOutHandle() {
            this.isQrCode = []
        },
        bannerMoveHandle(n, o) {
            //重置位置
            //y
            // this.leftLi[o].className=''
            // this.leftLi[n].className=''
            for (var i = 0; i < this.leftLi.length; i++) {
                this.leftLi[i].className = ''
            }
            this.leftLi[o].style[this.transform] = 'translate3d(0,0,0)'
            this.leftLi[o].style['opacity'] = '1'
            this.leftLi[n].style[this.transform] = 'translate3d(0,288px,0)'
            this.leftLi[n].style['opacity'] = '0'

            //x
            // this.rightLi[o].className=''
            // this.rightLi[n].className=''
            for (var i = 0; i < this.rightLi.length; i++) {
                this.rightLi[i].className = ''
            }
            this.rightLi[o].style[this.transform] = 'translate3d(0,0,0)'
            this.rightLi[o].style['opacity'] = '1'
            this.rightLi[n].style[this.transform] = 'translate3d(680px,0,0)'
            this.rightLi[n].style['opacity'] = '0'

            clearTimeout(this.tapTimer)
            this.tapTimer = setTimeout(() => {
                this.addClass(this.leftLi[o], 'transition-y-start')
                this.addClass(this.leftLi[n], 'transition-y-start')
                this.addClass(this.rightLi[o], 'transition-x-start')
                this.addClass(this.rightLi[n], 'transition-x-start')

                this.leftLi[o].style[this.transform] = 'translate3d(0,-288px,0)'
                this.leftLi[o].style['opacity'] = '0'
                this.leftLi[n].style[this.transform] = 'translate3d(0,0,0)'
                this.leftLi[n].style['opacity'] = '1'

                this.rightLi[o].style[this.transform] = 'translate3d(-680px,0,0)'
                this.rightLi[o].style['opacity'] = '0'
                this.rightLi[n].style[this.transform] = 'translate3d(0px,0,0)'
                this.rightLi[n].style['opacity'] = '1'

                //end事件
                var _this = this
                this.leftLi[n].removeEventListener(_this.transitionEnd, _this.moveFn, false)
                this.leftLi[n].addEventListener(_this.transitionEnd, _this.moveFn, false)

                // this.rightLi[n].removeEventListener('webkitTransitionEnd',_this.moveFn,false)
                // this.rightLi[n].addEventListener('webkitTransitionEnd',_this.moveFn,false)
            }, 30)
        },
        paginationHandle(index) {
            if (this.isMoveing) {
                this.nowIndex = index;
                this.navActive = []
                this.navActive[index] = true
                this.isMoveing = false
            }
        },
        scrollHandle() {
            window.addEventListener('scroll', () => {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
                // console.log(nowScrollTop);
                if (nowScrollTop > 0) {
                    this.isFixed = true
                } else {
                    this.isFixed = false
                }
            }, false)
        },
        moveBar(obj, target, time) {
            if (obj.raf) cancelAnimationFrame(obj.raf);
            // obj.raf = null;
            var startTime = Date.now();
            var time = time;
            var curNum = -100;
            var target = target;
            //重置

            /*
             * Tween.js
             * t: current time（当前时间）
             * b: beginning value（初始值）
             * c: change in value（变化量）
             * d: duration（持续时间）
             */
            var tween = {
                linear: function (t, b, c, d) {
                    return c * t / d + b;
                },
                easeInQuad: function (t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function (t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function (t, b, c, d) {
                    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                    return -c / 2 * ((--t) * (t - 2) - 1) + b;
                }
            }
            //var scale=1-Math.max(0,(startTime - changeTime + time)/time);
            var run = () => {
                var changeTime = Date.now() - startTime;
                if (changeTime >= time) {
                    changeTime = time;
                }
                var value = tween.linear(changeTime, curNum, target - curNum, time);
                // var scale = Math.round(((value + 90) / (target + 90)) * 100);
                obj.style[this.transform] = 'translate3d(' + value + '%,0,0)'
                if (changeTime == time) {
                    if (this.nowIndex >= this.aMPage.length - 1) {
                        this.nowIndex = 0
                    } else {
                        this.nowIndex++
                    }
                    cancelAnimationFrame(obj.raf);
                } else {
                    cancelAnimationFrame(obj.raf);
                    obj.raf = requestAnimationFrame(run);
                }
            }
            run();
        },
        downloadMobile() {
            var u = window.navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            console.log(u, isAndroid, isIOS);
            this.isLoading = true;

            //其他浏览器
            if (isIOS) {
                //com.baidu.tieba:// //ios app协议
                window.location.href = "zldd://main";
                setTimeout(() => {
                    this.isLoading = false
                    window.location.href = "https://apps.apple.com/cn/app/%E6%8D%A1%E5%AF%8C%E5%AE%9D/id1466062624?from=singlemessage&isappinstalled=0";
                }, 1000)
            } else if (isAndroid) {
                //微信
                if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                    // alert('weixin')
                    // this.isLoading = false;
                    // this.isWxMark = true;
                    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
                    return
                }
                window.location.href = "zldd://main";
                setTimeout(() => {
                    this.isLoading = false
                    window.location.href = this.diandianAndroidDownLoadUrl;
                }, 1000)
            }

        },
        addClass(obj, sClass) {
            if (obj.className.indexOf(sClass) == -1) {
                if (obj.className) {
                    obj.className += ' ' + sClass;
                } else {
                    obj.className += sClass;
                }
            }
        },
        removeClass(obj, sClass) {
            var aClass = obj.className.split(' ');
            for (var i = 0; i < aClass.length; i++) {
                if (aClass[i] == sClass) {
                    aClass[i] = '';
                }
            }
            obj.className = aClass.join(' ').replace(/(^\s*)|(\s*$)/g, "")
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// flatindex.vue?12a8394e